import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Survey } from '../../classes';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewComponent implements OnInit {
  survey: Survey;
  replyFormGroup: FormGroup;
  open_at: FormControl;
  close_at: FormControl;
  subscriptions = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) {
    
    this.replyFormGroup = new FormGroup({
      questions: new FormGroup({}),
      serverTimeOffset: new FormControl(0)
    });
  }

  ngOnInit() {
    if (this.route.snapshot.data.view) {
      const {surveyData } = this.route.snapshot.data.view;
      this.survey = new Survey(surveyData.id, surveyData.type);
      this.addControls();
      this.loadInitialData(surveyData);
      this.cdRef.detectChanges();
    } else {
      throw new Error('survey is not found.');
    }
  }
  loadInitialData(surveyData) {
    this.survey.load(surveyData)
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  addControls() {
    this.open_at = new FormControl(this.survey.open_at);
    this.close_at = new FormControl(this.survey.open_at);
    this.replyFormGroup.setControl('open_at', this.open_at);
    this.replyFormGroup.setControl('close_at', this.close_at);
  }
  trackByIdFn(index: number, value: any) {
    return value.id;
  }
}
